import template from './labelEdit.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
controller: class controller {
    constructor($mdDialog, $mdMedia, eventService, labelService, uiService, Label) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = () => {
        ctrl.destroyWatch = eventService.onLabelEdit((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {
                label: params.label ? angular.copy(params.label) : Label.blank()
              },
              template,
              controllerAs: '$ctrl',
              controller(LabelType, label) {
                const ctr = this;
                ctr.label = label;
                ctr.availableTypes = LabelType.available();
                ctr.isEditingLabel = _.isUuid(label.id);
                ctr.pickColor = false;
                ctr.colorPicked = (color) => {
                  ctr.pickColor = false;
                  ctr.label.color = color;
                };
                ctr.confirm = () => {
                  if (ctr.label.name !== '' && ctr.label.type !== '') {
                    $mdDialog.hide(ctr.label);
                  } else {
                    uiService.toast({
                      text: {
                        p1: 'Status',
                        p2: 'name and type',
                        p3: 'are required'
                      },
                      warn: true
                    });
                  }
                };
                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((result) => {
              const label = result;
              if (!_.isUuid(label.id)) {
                labelService.createLabel(label).then((data) => {
                  if (data.status) {
                    label.id = data.id;
                    label.isNew = true;
                    ctrl.onFinished({ label });
                    uiService.toast({
                      text: {
                        p1: 'Status',
                        p2: label.getName(),
                        p3: 'has been added'
                      }
                    });
                  }
                });
              } else {
                delete label.isSelected;
                labelService.updateLabel(label).then((data) => {
                  if (data.status) {
                    ctrl.onFinished({ label });
                    uiService.toast({
                      text: {
                        p1: 'Status',
                        p2: label.getName(),
                        p3: 'has been updated'
                      }
                    });
                  }
                });
              }
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
